import React from 'react';

/**
 * CrewVex-drawn menu glyphs (24 grid). One coral detail per glyph:
 * `cvx-ng-acc` = filled detail, `cvx-ng-accs` = line detail,
 * `cvx-ng-d` = the path that draws itself on `draw` glyphs.
 */
const ACC = 'cvx-ng-acc';
const ACCS = 'cvx-ng-accs';
const D = 'cvx-ng-d';

export const NAV_GLYPH_DEFS = {
  dashboard: {
    id: 'dashboard',
    move: 'squash',
    render: () => (
      <>
        <rect x="3" y="3" width="7.5" height="9" rx="1.75" />
        <rect x="13.5" y="12" width="7.5" height="9" rx="1.75" />
        <rect x="3" y="15" width="7.5" height="6" rx="1.75" />
        <rect className={ACC} x="13.5" y="3" width="7.5" height="6" rx="1.75" />
      </>
    ),
  },
  ai: {
    id: 'ai',
    move: 'twinkle',
    render: () => (
      <>
        <path d="M12 4 Q13.2 10.8 20 12 Q13.2 13.2 12 20 Q10.8 13.2 4 12 Q10.8 10.8 12 4Z" />
        <circle className={ACC} cx="18.6" cy="5.4" r="1.7" />
      </>
    ),
  },
  route: {
    id: 'route',
    move: 'draw',
    draw: true,
    render: () => (
      <>
        <circle cx="6" cy="18.5" r="2.5" />
        <path className={D} d="M8.5 18.5h8.25a3.25 3.25 0 0 0 0-6.5H7.25a3.25 3.25 0 0 1 0-6.5H15.5" />
        <circle className={ACC} cx="18" cy="5.5" r="2.5" />
      </>
    ),
  },
  schedule: {
    id: 'schedule',
    move: 'flip',
    render: () => (
      <>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
        <path d="M8 3v4M16 3v4M3.5 10h17" />
        <rect className={ACC} x="13" y="13.25" width="4" height="4" rx="1" />
      </>
    ),
  },
  jobs: {
    id: 'jobs',
    move: 'tilt',
    render: () => (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2.5" />
        <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M3 12.5h7M14 12.5h7" />
        <rect className={ACC} x="10" y="11" width="4" height="3.25" rx="1" />
      </>
    ),
  },
  customers: {
    id: 'customers',
    move: 'nod',
    render: () => (
      <>
        <rect x="3" y="5" width="18" height="14.5" rx="2.5" />
        <path d="M5.75 16.5c.5-1.6 1.8-2.5 3.25-2.5s2.75.9 3.25 2.5M15 10.5h3M15 13.75h3" />
        <circle className={ACC} cx="9" cy="10.75" r="2.25" />
      </>
    ),
  },
  billing: {
    id: 'billing',
    move: 'rise',
    render: () => (
      <>
        <path d="M5.5 3.5h13v17l-2.17-1.4-2.16 1.4L12 19.1l-2.17 1.4-2.16-1.4-2.17 1.4z" />
        <path d="M9 8h6M9 11.25h6" />
        <path className={ACCS} d="M9 15h3.5" strokeWidth={2.25} />
      </>
    ),
  },
  estimates: {
    id: 'estimates',
    move: 'nod',
    render: () => (
      <>
        <path d="M15.5 4.5h2A1.5 1.5 0 0 1 19 6v14a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 20V6a1.5 1.5 0 0 1 1.5-1.5h2" />
        <rect x="8.5" y="2.75" width="7" height="3.5" rx="1" />
        <path d="M12.5 11h3.5M12.5 16h3.5M8.25 16h.01" />
        <path className={ACCS} d="M7.75 11l1.25 1.25 2-2.25" strokeWidth={2} />
      </>
    ),
  },
  reports: {
    id: 'reports',
    move: 'draw',
    draw: true,
    render: () => (
      <>
        <path d="M4 4v15a1 1 0 0 0 1 1h15" />
        <path className={D} d="M7.5 15.5l3.5-4 3 2.5 3.25-4" />
        <circle className={ACC} cx="18.75" cy="8.25" r="1.75" />
      </>
    ),
  },
  emails: {
    id: 'emails',
    move: 'rise',
    render: () => (
      <>
        <rect x="3" y="6.5" width="15.5" height="13" rx="2.5" />
        <path d="M3.5 8.5l6.6 4.6a1.8 1.8 0 0 0 2.05 0L18 9" />
        <circle className={ACC} cx="19.5" cy="5.5" r="2.5" />
      </>
    ),
  },
  team: {
    id: 'team',
    move: 'wave',
    render: () => (
      <>
        <path d="M3.5 19.5c.6-3 2.8-4.75 5.5-4.75s4.9 1.75 5.5 4.75M16 4.9a3.1 3.1 0 0 1 0 6.2M17.25 14.9c1.9.5 2.95 2.1 3.25 4.6" />
        <circle className={ACC} cx="9" cy="8" r="3.1" />
      </>
    ),
  },
  catalog: {
    id: 'catalog',
    move: 'squash',
    render: () => (
      <>
        <path d="M20.5 8.2a1.8 1.8 0 0 0-.9-1.55l-6.7-3.85a1.8 1.8 0 0 0-1.8 0L4.4 6.65A1.8 1.8 0 0 0 3.5 8.2v7.6a1.8 1.8 0 0 0 .9 1.55l6.7 3.85a1.8 1.8 0 0 0 1.8 0l6.7-3.85a1.8 1.8 0 0 0 .9-1.55z" />
        <path d="M3.8 7.1L12 11.8l8.2-4.7M12 21.4v-9.6" />
        <path className={ACCS} d="M7.75 4.6l8.2 4.75" strokeWidth={2.25} />
      </>
    ),
  },
  company: {
    id: 'company',
    move: 'nod',
    render: () => (
      <>
        <path d="M6.5 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16M6.5 12H4.5a1.5 1.5 0 0 0-1.5 1.5V21M17.5 9h2a1.5 1.5 0 0 1 1.5 1.5V21M2.5 21h19M10 7h4M10 10.5h4M10 14h4" />
        <path className={ACC} d="M10.5 21v-2.25a1.5 1.5 0 0 1 3 0V21z" />
      </>
    ),
  },
  history: {
    id: 'history',
    move: 'spinback',
    render: () => (
      <>
        <path d="M3.5 12a8.5 8.5 0 1 0 2.5-6L3.5 8.5" />
        <path d="M3.5 4v4.5H8" />
        <path className={ACCS} d="M12 7.5V12l3 1.75" strokeWidth={2} />
      </>
    ),
  },
  plans: {
    id: 'plans',
    move: 'twinkle',
    render: () => (
      <>
        <path d="M6.5 3.5h11L21 9l-9 11.5L3 9z" />
        <path d="M3 9h18M9.5 3.5L8 9l4 11.5L16 9l-1.5-5.5" />
        <path className={ACC} d="M9.5 3.5h5L16 9H8z" />
      </>
    ),
  },
  cancellations: {
    id: 'cancellations',
    move: 'shake',
    render: () => (
      <>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
        <path d="M8 3v4M16 3v4M3.5 10h17" />
        <path className={ACCS} d="M10 13.25l4 4M14 13.25l-4 4" strokeWidth={2} />
      </>
    ),
  },
  audit: {
    id: 'audit',
    move: 'spinback',
    render: () => (
      <>
        <path d="M9.5 6h11M9.5 12h11M9.5 18h11" />
        <circle cx="4.75" cy="12" r="1.5" />
        <circle cx="4.75" cy="18" r="1.5" />
        <circle className={ACC} cx="4.75" cy="6" r="1.75" />
      </>
    ),
  },
  invites: {
    id: 'invites',
    move: 'rise',
    render: () => (
      <>
        <rect x="3" y="7" width="15" height="12.5" rx="2.5" />
        <path d="M3.5 9l6.4 4.4a1.8 1.8 0 0 0 2.05 0L17.5 9.5" />
        <path className={ACCS} d="M19.5 2.75v5M17 5.25h5" strokeWidth={2} />
      </>
    ),
  },
  cleanup: {
    id: 'cleanup',
    move: 'squash',
    render: () => (
      <>
        <path d="M4 5.75v12.5c0 1.5 3.6 2.75 8 2.75s8-1.25 8-2.75V5.75M4 12c0 1.5 3.6 2.75 8 2.75s8-1.25 8-2.75" />
        <ellipse className={ACC} cx="12" cy="5.75" rx="8" ry="2.75" />
      </>
    ),
  },
  account: {
    id: 'account',
    move: 'nod',
    render: () => (
      <>
        <circle cx="12" cy="12" r="9.5" />
        <path d="M7 19.1v-.6A2.5 2.5 0 0 1 9.5 16h5a2.5 2.5 0 0 1 2.5 2.5v.6" />
        <circle className={ACC} cx="12" cy="10" r="3" />
      </>
    ),
  },
};
